import cssUtil from 'gw-portals-util-js/CssUtil';

import ClaimTypeView from 'text!../views/ca-claim-type.html';
import CollisionLossDetailsView from 'text!../views/ca-collision-loss-details.html';
import CollisionVehiclesView from 'text!../views/ca-collision-vehicles.html';
import TheftDetailsView from 'text!../views/ca-theft-details.html';
import GlassDetailsView from 'text!../views/ca-glass-details.html';
import CABaseFnolWizardCtrl from 'edge/fnol/ca/controllers/CABaseFnolWizardCtrl';
import ClaimTypeCtrl from 'edge/fnol/ca/controllers/CAClaimTypeCtrl';
import CollisionDetailsCtrl from 'edge/fnol/ca/controllers/CACollisionDetailsCtrl';
import CollisionVehiclesCtrl from 'edge/fnol/ca/controllers/CACollisionVehiclesCtrl';
import GlassOrTheftDetailsCtrl from 'edge/fnol/ca/controllers/CAGlassOrTheftDetailsCtrl';
import loadGoogleMapsAPI from 'gw-portals-google-maps-js';

import CAFleetCtrl from '../CAFleet/CAFleetCtrl';
import CAFleetView from 'text!../CAFleet/CAFleet.html';
import CAFleetStyles from '../CAFleet/CAFleet-hashed.scss';

export default function () {
    const caBaseFnolWizard = {
        name: 'caBaseFnolWizard',
        parent: 'baseFnolWizard',
        abstract: true,
        controller: CABaseFnolWizardCtrl,
        template: '<div ui-view></div>',
        data: {
            trackingUrl: ''
        }
    };

    loadGoogleMapsAPI();

    return {
        caBaseFnolWizard: caBaseFnolWizard,
        caClaimType: {
            name: 'caClaimType',
            parent: caBaseFnolWizard,
            template: ClaimTypeView,
            controller: ClaimTypeCtrl
        },
        caFleet: {
            name: 'caFleet',
            parent: caBaseFnolWizard,
            template: cssUtil.hashTemplate(CAFleetView, CAFleetStyles),
            controller: CAFleetCtrl,
            controllerAs: '$ctrl'
        },
        caCollisionLossDetails: {
            name: 'caCollisionLossDetails',
            parent: caBaseFnolWizard,
            template: CollisionLossDetailsView,
            controller: CollisionDetailsCtrl
        },
        caCollisionVehicles: {
            name: 'caCollisionVehicles',
            parent: caBaseFnolWizard,
            template: CollisionVehiclesView,
            controller: CollisionVehiclesCtrl
        },
        caTheftDetails: {
            name: 'caTheftDetails',
            parent: caBaseFnolWizard,
            template: TheftDetailsView,
            controller: GlassOrTheftDetailsCtrl
        },
        caGlassDetails: {
            name: 'caGlassDetails',
            parent: caBaseFnolWizard,
            template: GlassDetailsView,
            controller: GlassOrTheftDetailsCtrl
        }
    };
}
